import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { ChevronDown } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// "Books" nav item with a dropdown listing all published books + an "All Books" link.
export default function BooksNavMenu({ mobile = false }) {
  const [books, setBooks] = useState([]);
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const closeTimer = useRef(null);

  useEffect(() => {
    axios.get(`${API}/books-catalog`).then((r) => setBooks(r.data || [])).catch(() => {});
  }, []);

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onClick);
    return () => {
      document.removeEventListener('mousedown', onClick);
      if (closeTimer.current) clearTimeout(closeTimer.current);
    };
  }, []);

  const openMenu = () => {
    if (closeTimer.current) clearTimeout(closeTimer.current);
    setOpen(true);
  };
  const scheduleClose = () => {
    if (closeTimer.current) clearTimeout(closeTimer.current);
    closeTimer.current = setTimeout(() => setOpen(false), 350);
  };

  return (
    <div
      className="relative"
      ref={ref}
      onMouseEnter={() => !mobile && openMenu()}
      onMouseLeave={() => !mobile && scheduleClose()}
    >
      <button
        onClick={() => setOpen((o) => !o)}
        className="nav-link text-sm flex items-center gap-1"
        data-testid="nav-books-dropdown"
      >
        Books <ChevronDown className="w-3 h-3" />
      </button>
      {open && (
        <div
          className={`${mobile ? 'mt-1 w-full' : 'absolute left-0 top-full pt-2 w-60'} z-50`}
          data-testid="books-dropdown-menu"
        >
          <div className="bg-white rounded-lg shadow-xl border border-gray-200 py-2">
          <Link
            to="/books"
            onClick={() => setOpen(false)}
            data-testid="books-dropdown-all"
            className="block px-4 py-2 text-sm font-bold text-[#1B4B5A] hover:bg-[#FDF6EC]"
          >
            All Books
          </Link>
          <div className="border-t border-gray-100 my-1"></div>
          {books.length === 0 ? (
            <span className="block px-4 py-2 text-sm text-gray-400">No books yet</span>
          ) : (
            books.map((b) => (
              <Link
                key={b.id}
                to={`/books/${b.slug}`}
                onClick={() => setOpen(false)}
                data-testid={`books-dropdown-item-${b.slug}`}
                className="block px-4 py-2 text-sm text-gray-700 hover:bg-[#FDF6EC] truncate"
              >
                {b.title}
              </Link>
            ))
          )}
          </div>
        </div>
      )}
    </div>
  );
}
